// eslint-disable-next-line react/display-name
const withInnerAs = (Wrapped) => ({ innerAs, ...rest }) => {
  return <Wrapped as={innerAs} {...rest} />
}

export default withInnerAs
